import React from 'react'
import { useSessionStateStore } from '@renderer/stores/sessionState'
import PhotoStripCapture from './PhotostripCapture'
import FlipbookCapture from './FlipbookCapture'
import JapaneseCapture from './JapaneseCapture'

const Capture: React.FC = () => {
  const { userPreferences } = useSessionStateStore()
  if (userPreferences.boothMode === 'japanese') {
    return <JapaneseCapture />
  } else if (userPreferences.boothMode === 'flipbook') {
    return <FlipbookCapture />
  } else {
    return <PhotoStripCapture />
  }
}

export default Capture
